import { useState, useEffect, useRef } from 'react';
import { fetchNasaApod, getCachedApod } from '../utils/nasaApod';

const useNasaApod = () => {
  const initialRef = useRef(null);
  if (initialRef.current === null) {
    const cached = getCachedApod();
    initialRef.current = { apod: cached, loading: !cached };
  }

  const [apod, setApod] = useState(initialRef.current.apod);
  const [loading, setLoading] = useState(initialRef.current.loading);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const load = async () => {
      const hadCache = Boolean(getCachedApod());

      try {
        if (!hadCache) {
          setLoading(true);
        }
        setError('');

        const result = await fetchNasaApod();
        if (!active) return;

        setApod(result);
        setLoading(false);
      } catch (err) {
        if (!active) return;

        console.error('NASA APOD fetch error:', err);
        const fallback = getCachedApod();
        if (fallback) {
          setApod(fallback);
          setError('');
        } else {
          setError("Today's NASA feature couldn't be loaded. Try again in a moment.");
        }
        setLoading(false);
      }
    };

    load();

    return () => {
      active = false;
    };
  }, []);

  return { apod, loading, error };
};

export default useNasaApod;